import React from 'react';
import { Button, Icon, Text } from '@spothero/ui';
import { useMobileWebRelevanceVariation } from 'hooks/use-mobile-web-relevance-variation';
import { useMobileViewToggle } from 'pages/search/components/search-component/mobile-view-toggle/hooks/use-mobile-view-toggle';
const ToggleOption = ({ IconOption, label, onClick }) => {
    const variantStyles = {
        variant_1: {
            rounded: 'md',
            marginLeft: '2',
            padding: 4,
        },
    };
    const { variation, isVariation1 } = useMobileWebRelevanceVariation();
    const buttonVariant = isVariation1 ? 'secondary' : 'tertiary';
    const buttonVariantStyle = variantStyles[variation] || {
        borderWidth: 0,
        padding: 0,
    };
    return (<Button key={label} onClick={onClick} variant={buttonVariant} paddingLeft="3" {...buttonVariantStyle}>
            <Icon as={IconOption} height="4.5" width="4.5"/>
            <Text paddingLeft="1" fontWeight="semibold">
                {label}
            </Text>
        </Button>);
};
export default function MobileViewToggle() {
    const { handleClick, activeOption } = useMobileViewToggle();
    return <ToggleOption onClick={handleClick} {...activeOption}/>;
}
